import React, { useState, useRef } from 'react';
import Layout from '../layout/layout';


const ContactPage = () => {
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const formRef = useRef(null);

    const submitForm = (e) => {
        e.preventDefault();
        let formData = new FormData(formRef.current);
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(formData).toString(),
        })
        .then(() => setHasSubmitted(true))
        .catch((error) => setHasSubmitted(true));
    }

    return (
        <Layout title="Contact" showFooter={false}>
            <div className='contact'>
                <div className='contact__container'>
                    {hasSubmitted ? (
                        <h3>The form has been successfully submitted. Thanks!</h3>
                    ) : (
                        <div>
                            <h1>Contact</h1>
                            
                            <form ref={formRef} className='contact__form' method='POST' name="contact" data-netlify="true" onSubmit={submitForm}>
                                <input type="hidden" name="form-name" value="contact" />
                                <div className='contact__form__field'>
                                    <input name='name' type='text' placeholder='Name' id='contact-name' required />
                                    <label htmlFor='contact-name'>Name</label>
                                </div>
                                <div className='contact__form__field'>
                                    <input name='email' type='text' placeholder='Email' id='contact-email' required />
                                    <label htmlFor='contact-email'>Email</label>
                                </div>
                                <div className='contact__form__field'>
                                    <textarea name='message' placeholder='Email' id='contact-message' className='textarea' required />
                                    <label htmlFor='contact-message'>Message</label>
                                </div>
                                <div className='contact__form__field'>
                                    <button type='submit' className='btn'>Submit</button>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    )
}

export default ContactPage;